<app-anonymous-page-layout>
  <app-card>
    <app-page-title [title]="'PAGE.PASSWORD_RESET.TITLE' | translate" style="--page-title-padding-bottom: var(--size-xl)"></app-page-title>

    <form class="form-layout" [formGroup]="passwordForm" (ngSubmit)="resetPassword()">
      <app-form-element
        class="item"
        [label]="'LABEL.NEW_PASSWORD' | translate"
        inputId="new-password"
        [errors]="formHelper.getErrors('password')"
      >
        <app-input-password inputId="new-password" [control]="passwordForm.controls.password"></app-input-password>
      </app-form-element>

      <app-form-element
        class="item"
        [label]="'LABEL.CONFIRM_PASSWORD' | translate"
        inputId="confirm-password"
        [errors]="formHelper.getErrors('confirmPassword')"
      >
        <app-input-password inputId="confirm-password" [control]="passwordForm.controls.confirmPassword"></app-input-password>
      </app-form-element>

      <div class="actions" style="margin-top: var(--size-xl)">
        <app-button
          [label]="'PAGE.PASSWORD_RESET.BUTTON_RESET_PASSWORD' | translate"
          [disabled]="isResetting"
          [stretched]="true"
          type="submit"
        ></app-button>
      </div>
    </form>

    <div class="navigation" style="margin-top: var(--size-lg); text-align: center">
      <app-button
        [label]="'PAGE.PASSWORD_RESET.BUTTON_BACK_TO_LOGIN' | translate"
        buttonStyle="secondary"
        [routerLink]="routes.login.url()"
        [stretched]="true"
      ></app-button>
    </div>
  </app-card>
</app-anonymous-page-layout>
